import { CalApiError } from "@/lib/cal/types";

/**
 * True when Cal.com rejected the request's access token itself: a 401 that names an invalid
 * token or an unknown OAuth client. Other 401s (for example a permission check) do not count.
 *
 * Separate from `lib/errors/cal.ts` because `lib/cal/utils.ts` calls it, and `cal.ts` imports
 * `lib/cal/admin.ts`, which imports `lib/cal/utils.ts`.
 */
export function isCalInvalidAccessTokenError(error: unknown): error is CalApiError {
  if (!(error instanceof CalApiError)) {
    return false;
  }

  if (error.statusCode !== 401) {
    return false;
  }

  const normalizedMessage = error.message.toLowerCase();
  return (
    normalizedMessage.includes("invalid access token") ||
    normalizedMessage.includes("oauth client not found")
  );
}
